import { DOCUMENT } from '@angular/common';
import {
    Inject,
    Injectable,
} from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class ServerConfiguration {
    public get baseHref() {
        const base = this._document.querySelector('base');

        return base && base.href || '';
    }

    constructor(
        @Inject(DOCUMENT) private _document: Document,
    ) { }
}
